document.addEventListener('DOMContentLoaded', function() {
    // your code here
    sessionStorage.setItem("userAnswers", "");
    sessionStorage.setItem("intakeQuizResults", "");
    sessionStorage.setItem("customRecommendations", "");
    sessionStorage.setItem('requestSent', 'false');
});

function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

function conditionalQuestionCheck(questionIndex, userAnswers){
    let skipNextQuestion = false;
    let conditionalQuestion = document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).getAttribute('data-conditional');
    if(conditionalQuestion == "yes"){
        let conditionalHandles = document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).getAttribute('data-conditionalhandles');
        let conditionalValues = document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).getAttribute('data-conditionalvalues');
        conditionalHandles = conditionalHandles.split("<>");
        conditionalValues = conditionalValues.split("<>");
        let userAnswersJson = JSON.parse(userAnswers);
        for(let i=0 ; i<conditionalHandles.length ; ++i){
            let handleValue = userAnswersJson[conditionalHandles[i]];
            if(handleValue != conditionalValues[i]){
                skipNextQuestion = true;
                break;
            }
        }
    }

    return skipNextQuestion;
}

document.querySelectorAll(".intake-quiz-form__mcqs__option__button").forEach(function(button) {
    button.addEventListener("click", async function(){ 
        // code to execute when button is clicked
        let questionIndex = +this.dataset.index;
        let questionHandle = document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).getAttribute('data-questionhandle');

        let userAnswers = sessionStorage.getItem("userAnswers");
        let skipQuestion = false;
        let answer = this.textContent.trim().toLowerCase(); 

        let mandatoryQuestion = document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).getAttribute('data-questionmandatory');

        if(mandatoryQuestion == "true"){
            
            let mandatoryOptionName = document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).getAttribute('data-questionmandatoryname');
            mandatoryOptionName = mandatoryOptionName.trim().toLowerCase();
            if(answer == mandatoryOptionName) {
                document.querySelector('.intake-quiz-form__mcqs__error__message__' + questionIndex).style.display = 'none';
            } else {
                document.querySelector('.intake-quiz-form__mcqs__error__message__' + questionIndex).style.display = 'block';
            return;
            }

        }
        
        if(userAnswers){
            userAnswers = JSON.parse(userAnswers);
            userAnswers[questionHandle] = answer;
            userAnswers = JSON.stringify(userAnswers);
            sessionStorage.setItem("userAnswers", userAnswers); 
        }else{
            userAnswers = {};
            userAnswers[questionHandle] = answer;
            userAnswers = JSON.stringify(userAnswers);
            sessionStorage.setItem("userAnswers", userAnswers); 
        }
        
        let nextQuestionIndex = questionIndex + 1;
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).classList.remove('fadeIn');
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).classList.add('fadeOut');
        await delay(400);
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).style.display = 'none';
        skipQuestion = conditionalQuestionCheck(nextQuestionIndex, userAnswers);
        if (skipQuestion) {
            userAnswers = JSON.parse(userAnswers);
            let nextQHandle = document.querySelector(".intake-quiz-form__mcqs__iteration__" + nextQuestionIndex).dataset.questionhandle;
            userAnswers[nextQHandle] = '';
            userAnswers = JSON.stringify(userAnswers);
            sessionStorage.setItem("userAnswers", userAnswers);
            nextQuestionIndex = nextQuestionIndex + 1;
        }
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + nextQuestionIndex).style.display = 'block';
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + nextQuestionIndex).classList.remove('fadeOut');
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + nextQuestionIndex).classList.add('fadeIn');
        document.querySelector('.e-btn-back').dataset.currentindex = nextQuestionIndex;
        document.querySelector('.e-slidenr-current').textContent = nextQuestionIndex + 1;

        // progress bar update
        let totalQuestions = document.querySelector('.e-progressbar--mesure').dataset.totalquestions;
        let barWidth = ((nextQuestionIndex + 1) / totalQuestions) * 100;
        document.querySelector('.e-progressbar--mesure').style.width = barWidth + '%';

    });
});

document.querySelector(".e-btn-back").addEventListener("click", async function(){
    let userAnswers = sessionStorage.getItem("userAnswers");
    let skipQuestion = false;
    let currentQuestionIndex = + this.dataset.currentindex;
    if(currentQuestionIndex){
        let previousQuestionIndex = currentQuestionIndex - 1;
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + currentQuestionIndex).classList.remove('fadeIn');
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + currentQuestionIndex).classList.add('fadeOut');
        await delay(400);
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + currentQuestionIndex).style.display = 'none';
        skipQuestion = conditionalQuestionCheck(previousQuestionIndex, userAnswers);
        if(skipQuestion){
            userAnswers = JSON.parse(userAnswers);
            let prevQHandle = document.querySelector(".intake-quiz-form__mcqs__iteration__" + previousQuestionIndex).dataset.questionhandle;
            userAnswers[prevQHandle] = '';
            userAnswers = JSON.stringify(userAnswers);
            sessionStorage.setItem("userAnswers", userAnswers);
            previousQuestionIndex = previousQuestionIndex - 1;
        }
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + previousQuestionIndex).style.display = 'block';
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + previousQuestionIndex).classList.remove('fadeOut');
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + previousQuestionIndex).classList.add('fadeIn');
        document.querySelector('.e-btn-back').dataset.currentindex = previousQuestionIndex;
        document.querySelector('.e-slidenr-current').textContent = previousQuestionIndex + 1;

        //progress bar update
        let totalQuestions = document.querySelector('.e-progressbar--mesure').dataset.totalquestions;
        let barWidth = ((previousQuestionIndex + 1)/totalQuestions) * 100;
        document.querySelector('.e-progressbar--mesure').style.width = barWidth + "%";
        
    }
});

// profile details form function

function check_profile_details_form(inputForm) {
    var allInputsFilled = true;
    window.validationError = "Please fill in all the fields.";
    let eInputs = inputForm.querySelectorAll('.e-input input');
    eInputs.forEach(function (input) {

        input.classList.remove('is-error');

        if (input.value.length === 0) {
            // your code here
            input.classList.add('is-error');
            allInputsFilled = false;

        }else if (input.getAttribute('name') === 'age') {


            if (parseInt(input.value) < 16) {
                input.classList.add('is-error');
                window.validationError = "You have to be at least 18 years old.";
                allInputsFilled = false;
            }
            if (parseInt(input.value) > 100 || parseInt(input.value) !== parseFloat(input.value)) {
                input.classList.add('is-error');
                allInputsFilled = false;
            }

        }else if (input.getAttribute('name') === 'feet') {

            if (parseInt(input.value) < 2) {
              input.classList.add('is-error');
              window.validationError = "Please enter valid height.";
              allInputsFilled = false;
            }

            if (parseInt(input.value) > 10) {
              input.classList.add('is-error');
              window.validationError = "Please enter valid height.";
              allInputsFilled = false;
            }

        }else if (input.getAttribute('name') === 'inches') {

            if (parseInt(input.value) > 12) {
                input.classList.add('is-error');
                window.validationError = "Please enter valid height.";
                allInputsFilled = false;
            }
            
        }else if (input.getAttribute('name') === 'weight') {

            var val = parseInt(input.value);
           
            if (val < 88 || val > 440) {
                input.classList.add('is-error');
                window.validationError = "Please validate your current weight.";
                allInputsFilled = false;
            }
            
            if (val < 40 || val > 400) {
                input.classList.add('is-error');
                window.validationError = "Please validate your current weight.";
                allInputsFilled = false;
            }
          
        }
    });

    if (allInputsFilled) {
        return true;
    } else {
        return false;
    }
}

document.querySelector('.c-questionslide__button__secondary').addEventListener('click', async function() {
    // your code here
    let questionIndex = + this.dataset.index;
    let $error_selector = document.querySelector('.intake-quiz-form__mcqs__error__message__measurements__' + questionIndex);
    let slide_parent = this.closest('.b-profiledetails');
    let inputForm = slide_parent.querySelector('.b-form');

    if ( check_profile_details_form(inputForm)) {
        ($error_selector).classList.remove("fadeIn");
        ($error_selector).classList.add("fadeOut");
        await delay(400);
        ($error_selector).style.display = 'none';
        let profile_details = {
            "age": document.querySelector(".b-form input[name=age]").value,
            "height": {
            "feet": document.querySelector(".b-form input[name=feet]").value,
            "inch": document.querySelector(".b-form input[name=inches]").value
            },
            "weight": document.querySelector(".b-form input[name=weight]").value
        };
        let userAnswers = sessionStorage.getItem("userAnswers");

        if(userAnswers){
            userAnswers = JSON.parse(userAnswers);
            userAnswers["measurements"] = profile_details;
            userAnswers = JSON.stringify(userAnswers);
            sessionStorage.setItem("userAnswers", userAnswers); 
        }else{
            userAnswers = {};
            userAnswers["measurements"] = profile_details;
            userAnswers = JSON.stringify(userAnswers);
            sessionStorage.setItem("userAnswers", userAnswers); 
        }

        let nextQuestionIndex = questionIndex + 1;
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).classList.remove('fadeIn');
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).classList.add('fadeOut');
        await delay(400);
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + questionIndex).style.display = 'none';
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + nextQuestionIndex).style.display = 'block';
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + nextQuestionIndex).classList.remove('fadeOut');
        document.querySelector(".intake-quiz-form__mcqs__iteration__" + nextQuestionIndex).classList.add('fadeIn');
        document.querySelector('.e-btn-back').setAttribute('data-currentindex', nextQuestionIndex);
        document.querySelector('.e-slidenr-current').textContent = nextQuestionIndex + 1;

        //progress bar update
        let totalQuestions = document.querySelector('.e-progressbar--mesure').dataset.totalquestions;
        let barWidth = ((nextQuestionIndex + 1)/totalQuestions) * 100;
        document.querySelector('.e-progressbar--mesure').style.width = barWidth + "%";

    } else {
        document.querySelector('.b-form').classList.add('is-shaking');

        setTimeout(function () {
            document.querySelector('.b-form').classList.remove('is-shaking');
        }, 400);

        document.querySelector('.intake-quiz-form__mcqs__error__message__measurements__' + questionIndex).innerHTML = window.validationError;
        document.querySelector('.intake-quiz-form__mcqs__error__message__measurements__' + questionIndex).style.display = 'block';
        document.querySelector('.intake-quiz-form__mcqs__error__message__measurements__' + questionIndex).classList.remove('fadeOut');
        document.querySelector('.intake-quiz-form__mcqs__error__message__measurements__' + questionIndex).classList.add('fadeIn');
        
        return false;
    } 
});

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

document.querySelector('.c-questionslide__button__primary').addEventListener('click', async function() {
    // Your code here
    let firstname_field = document.querySelector('input[name="firstname"]');
    firstname_field.closest('.e-input').classList.remove('is-shaking');

    let lastname_field = document.querySelector('input[name="lastname"]');
    lastname_field.closest('.e-input').classList.remove('is-shaking');

    let email_field = document.querySelector('input[type="email"]');
    email_field.closest('.e-input').classList.remove('is-shaking');

    if (firstname_field.value === '') {
        setTimeout(function () {
            firstname_field.closest('.e-input').classList.add('is-shaking');
        }, 100);
    } else if (lastname_field.value === '') {
        setTimeout(function () {
            lastname_field.closest('.e-input').classList.add('is-shaking');
        }, 100);
    } else if (!validateEmail(email_field.value)) {
        setTimeout(function () {
            email_field.closest('.e-input').classList.add('is-shaking');
        }, 100);
    } else {
        let personal_details = {"first_name": firstname_field.value, "last_name": lastname_field.value, "email": email_field.value};
        let send_email_after = document.getElementById('email_address').dataset.sendemailafter;
        let userAnswers = sessionStorage.getItem("userAnswers");
        userAnswers = JSON.parse(userAnswers);
        userAnswers["send_email_after"] = send_email_after;
        userAnswers["personal_details"] = personal_details;
        userAnswers = JSON.stringify(userAnswers);
        sessionStorage.setItem("userAnswers", userAnswers);
        document.querySelector('.intake-quiz-form__inner').style.display = 'none';
        document.querySelector(".intake-quiz-form__calculation__progress__bar").style.display = 'block';
        document.querySelector(".intake-quiz-form__calculation__progress__bar").classList.remove('fadeOut');
        document.querySelector(".intake-quiz-form__calculation__progress__bar").classList.add('fadeIn');
        await delay(400);
        progressbar();
    }
    
});

function progressbar() {
    var duration = 4000; // it should finish in 5 seconds!
    var parent = document.querySelector('.b-progress');
    var width = parent.querySelector('.e-progressbar').clientWidth;
    var progressBar = parent.querySelector('.e-progressbar--mesure');
    progressBar.style.display = "block";
    progressBar.style.width = "0";
  
    var startTime;
    function animate(currentTime) {
      if (!startTime) {
        startTime = currentTime;
      }
  
      var timeElapsed = currentTime - startTime;
      var progress = timeElapsed / duration;
      
      progressBar.style.width = Math.min(progress * width, width) + 'px';
  
      parent.querySelectorAll('.e-progress-status p').forEach(function (p) {
        p.style.display = 'none';
      });
      if (Math.round(progress * 100) > 0 && Math.round(progress * 100) < 25) {
        parent.querySelector('.e-progress-status p:nth-child(1)').style.display = 'block';
      }
      if (Math.round(progress * 100) > 25 && Math.round(progress * 100) < 50) {
        parent.querySelector('.e-progress-status p:nth-child(2)').style.display = 'block';
      }
      if (Math.round(progress * 100) > 50 && Math.round(progress * 100) < 75) {
        parent.querySelector('.e-progress-status p:nth-child(3)').style.display = 'block';
      }
      if (Math.round(progress * 100) > 75 && Math.round(progress * 100) < 100) {
        parent.querySelector('.e-progress-status p:nth-child(4)').style.display = 'block';
      }
  
      parent.querySelector('.e-progressbar--percentage').textContent = Math.round(progress * 100) + '%';
  
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        let answers = prepare_answers();
        answers = JSON.stringify(answers);
        sessionStorage.setItem('intakeQuizResults', answers);
        window.location.href = '/pages/clovis-intake-quiz-dashboard';
      }
    }
  
    requestAnimationFrame(animate);
}